import { Column, Entity, ManyToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefMission } from './interface/IRefMission';
import { IRefChapterRubric } from './interface/IRefChapterRubric';

@Entity('ref_mission')
export class RefMission extends BaseEntity implements IRefMission{
  apiMapping = {
      id: 'id',
      name: 'name',
      hasMandatoryRecommendation: 'hasMandatoryRecommendation',
      isSo: 'isSo'
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column()
  hasMandatoryRecommendation: boolean;

  @Column()
  isSo: boolean;

  @Column({ nullable: true })
  isDeleted: boolean;

  @ManyToMany('RefChapterRubric', 'refMissions')
  refChapterRubrics: IRefChapterRubric[];
}
